import { useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import type { ImportTarget, PastSessionInput, PastSessionResult } from "../domain/pastSessionImport";
import { importPastSessions } from "../infrastructure/pastSessions.api";

/**
 * Sends a batch of past sessions. Whatever lists sessions or counts them —
 * caseloads, reports — is read again once any was created.
 */
export function usePastSessionImport(target: ImportTarget) {
    const queryClient = useQueryClient();
    const [sending, setSending] = useState(false);

    const send = useCallback(
        async (rows: PastSessionInput[]): Promise<PastSessionResult[]> => {
            setSending(true);
            try {
                const results = await importPastSessions(target, rows);
                if (results.some((result) => !result.error)) void queryClient.invalidateQueries();
                return results;
            } finally {
                setSending(false);
            }
        },
        [target, queryClient]
    );

    return { send, sending };
}
